export default __webpack_public_path__ + "static/media/Universidade_Federal_de_Goias.7b796548.png";